/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: bd23c504 (Thu Jun 11 17:44:43 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  ProgramType,
} from './'

/**
 *
 * @export
 * @interface CommunityDirectorLicensingBilling
 */
export interface CommunityDirectorLicensingBilling {
  /**
   * The name of the community managed by the director.
   * @type string
   * @memberof CommunityDirectorLicensingBilling
   */
  community: string
  /**
   *
   * @type ProgramType
   * @memberof CommunityDirectorLicensingBilling
   */
  program: ProgramType
  /**
   * The program unique identifier.
   * @type number
   * @memberof CommunityDirectorLicensingBilling
   */
  programKey?: number
  /**
   * The start date of the program first semester.
   * @type Date
   * @memberof CommunityDirectorLicensingBilling
   */
  semesterOneStartDate: Date
  /**
   *
   * @type CashAmount
   * @memberof CommunityDirectorLicensingBilling
   */
  tutorOwes: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof CommunityDirectorLicensingBilling
   */
  directorOwes: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof CommunityDirectorLicensingBilling
   */
  directorDue?: CashAmount
}

export function CommunityDirectorLicensingBillingFromJSON(
  json: any
): CommunityDirectorLicensingBilling {
  return CommunityDirectorLicensingBillingFromJSONTyped(json, false)
}

export function CommunityDirectorLicensingBillingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CommunityDirectorLicensingBilling {
  if (json === undefined || json === null) {
    return json
  }
  return {
    community: json['community'],
    program: json['program'],
    programKey: !exists(json, 'programKey') ? undefined : json['programKey'],
    semesterOneStartDate: new Date(json['semesterOneStartDate']),
    tutorOwes: CashAmountFromJSON(json['tutorOwes']),
    directorOwes: CashAmountFromJSON(json['directorOwes']),
    directorDue: !exists(json, 'directorDue')
      ? undefined
      : CashAmountFromJSON(json['directorDue']),
  }
}

export function CommunityDirectorLicensingBillingToJSON(
  value?: CommunityDirectorLicensingBilling | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    community: value.community,
    program: value.program,
    programKey: value.programKey,
    semesterOneStartDate: value.semesterOneStartDate
      .toISOString()
      .substr(0, 10),
    tutorOwes: CashAmountToJSON(value.tutorOwes),
    directorOwes: CashAmountToJSON(value.directorOwes),
    directorDue: CashAmountToJSON(value.directorDue),
  }
}
